export const PAYROLL_WORKSPACE_PAGES = Object.freeze({
  delivery: "runs-and-files",
  timesheets: "timesheet-imports",
  claims: "claim-approval",
  final: "final-payroll",
  unclaimed: "missing-claims",
});

const PAYROLL_PAGE_WORKSPACES = Object.freeze(
  Object.fromEntries(
    Object.entries(PAYROLL_WORKSPACE_PAGES).map(([workspace, page]) => [
      page,
      workspace,
    ]),
  ),
);

export const payrollWorkspaceFromPage = (page) => {
  const value = Array.isArray(page) ? page[0] : page;
  return PAYROLL_PAGE_WORKSPACES[value] || "timesheets";
};

export const payrollPageFromWorkspace = (workspace) =>
  PAYROLL_WORKSPACE_PAGES[workspace] || PAYROLL_WORKSPACE_PAGES.timesheets;
